import filter from "lodash/filter"
export default {
  computed: {
    price() {
      let price = ""

      if (!this.item.prices) {
        return false
      }

      if (this.item.prices.base_price === 0 && this.item.prices?.single) {
        return this.item.prices.single
      }

      if (this.item.low_price === 999999 || this.item.high_price === -999999) {
        return false
      }

      if (this.item.prices.base_price === 0) {
        return false
      }

      if (this.item.prices.base_price && typeof this.item.prices.base_price !== "number" && this.item.prices.base_price.includes("$")) {
        return this.item.prices.base_price
      }

      price = price + "From $" + this.item.prices.base_price

      if (filter(this.item.categories, { name: "Accommodation" }).length) {
        price = price + " per night"
      }

      return price
    },
    typeOfNoAvailability() {
      if (filter(this.item.categories, { name: "Accommodation" }).length) {
        return "Has rooms available on "
      }

      if (filter(this.item.categories, { name: "Tours &amp; Experiences" }).length) {
        return "Next tour available on "
      }

      return ""
    },
  },
}
